<ng-container *ngIf="cursor">
  <ng-container [ngSwitch]="cursor">
    <app-fluid-cursor *ngSwitchCase="'fluid'"></app-fluid-cursor>
    <app-dot-cursor *ngSwitchCase="'dot'"></app-dot-cursor>
    <app-circle-cursor *ngSwitchCase="'circle'"></app-circle-cursor>
    <app-circle-text-cursor *ngSwitchCase="'circle-text'"></app-circle-text-cursor>
    <app-axis-cursor *ngSwitchCase="'axis'"></app-axis-cursor>
  </ng-container>
</ng-container>
